module.exports = ".footer-text{\n\ttext-align: center;\n\tfont-family: 'Montserrat', sans-serif;\n\tfont-size: 16px;\n\tcolor: #FFFFFF;\n\tfont-weight: 600;\n}\n.footer-content{\n\tbackground-color: #242829;\n}\n.termsAndCondition{\n\tcolor: white;\n\ttext-decoration: underline;\n\tcursor: pointer;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/footer/footer.component.css
// module id = ./src/app/components/footer/footer.component.css
// module chunks = main